<div class="dialog-container animate" (mousedown)="containerClicked($event)" [@fadeInOutDialog]>
	<div class="dialog lg" [ngClass]="_classes" role="dialog">
		<ng-content></ng-content>
	</div>
</div>
